import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/employee'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(employee, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, employee, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  add(employee) {
    return http.post(`${resource}`, employee, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
